import { z } from 'zod';

import { optionalString, requiredString } from '@/shared/utils/validation';

export const updateUserInputSchema = z.object({
  firstName: requiredString(),
  lastName: requiredString(),
  email: requiredString().email(),
  companyName: optionalString(),
  groupId: optionalString(),
});
